import { useLayoutEffect, useRef, useState } from 'react'

export function usePatientDetailsMinHeight() {
  const ref = useRef<HTMLDivElement>(null)
  const [minHeight, setMinHeight] = useState<number | undefined>()

  useLayoutEffect(() => {
    if (!ref.current) return

    const paperBoundingClientRect = ref.current.getBoundingClientRect()
    setMinHeight(window.innerHeight - paperBoundingClientRect.y - 30)
  }, [])

  return { minHeight, ref }
}
